<template>
  <div class="marketplace-product-link d-flex flex-column position-relative">
    <div
      class="img-cover"
      :style="`background-image: url(${product.picture})`"
    ></div>
    <small class="text-secondary" v-show="false">
      {{ product.qty_lessons }} aulas
    </small>
    <h5 class="mb-4">{{ product.title }}</h5>
    <div class="flex-fill"></div>
    <div class="d-flex align-items-center justify-content-between">
      <div v-if="product.installments > 0">
        <div v-if="product.promotion">
          De:
          <small
            ><del
              >R$ {{ product.price }} <span class="text-capitalize"></span></del
          ></small>
          <br />Por:
          <strong>
            R$ {{ product.promotion }} <span class="text-capitalize"></span
          ></strong>
          <br />
          Ou
          <strong
            >{{ product.installments }}X de R$
            {{ installmentsPricePromotion }}</strong
          >
        </div>
        <div v-else>
          <strong> R$ {{ product.price }} <br />Ou </strong>
          <strong
            >{{ product.installments }}X de {{ installmentsPrice }}</strong
          >
        </div>
      </div>
      <div v-else-if="product.promotion && product.installments == 0">
        De:
        <small
          ><del
            >R$ {{ product.price }} <span class="text-capitalize"></span></del
        ></small>
        <br />Por:
        <strong>
          R$ {{ product.promotion }} <span class="text-capitalize"></span
        ></strong>
      </div>
      <div v-else>
        <strong>
          R$ {{ product.price }} <span class="text-capitalize"></span
        ></strong>
      </div>

      <button class="btn btn-primary btn-sm py-2 px-3" @click="dialog = true">
        Participar
      </button>
    </div>
    <b-modal
      v-model="dialog"
      hide-header
      hide-footer
      centered
      size="xl"
      body-class="borderless"
    >
      <benefit-details
        :product="product"
        @close="dialog = false"
      ></benefit-details>
    </b-modal>
  </div>
</template>

<script>
import { slugfy } from "@/functions/helpers.js";
import BenefitDetails from "./BenefitDetails.vue";

export default {
  components: { BenefitDetails },
  props: {
    product: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    slugfy
  },
  computed: {
    installmentsPricePromotion() {
      return (this.product.promotion / this.product.installments).toFixed(2);
    },
    installmentsPrice() {
      return (this.product.price / this.product.installments).toFixed(2);
    }
  }
};
</script>

<style lang="scss" scoped>
.marketplace-product-link {
  padding: 12px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  .img-cover {
    width: 100%;
    height: 0;
    padding-bottom: 60%;
    background-color: rgba(10, 5, 15, 0.7);
    background-size: cover;
    background-position-x: center;
    background-position-y: center;
    border-radius: 4px;
    margin-bottom: 16px;
  }
}
</style>
